<template>
  <button class="message-bell" type="button" :title="error ? '消息数量暂不可用，点击查看' : '消息中心'"
          :aria-label="`消息中心，${unreadCount}条未读`" @click="open">
    <el-badge :value="unreadCount" :max="99" :hidden="!unreadCount">
      <i class="el-icon-bell" aria-hidden="true" />
    </el-badge>
  </button>
</template>
<script>
import { approvalMessageSummary, approvalMessageEvents } from '@/api/crm/approvalMessage'
export default {
  data: () => ({ unreadCount: 0, error: false }),
  mounted() {
    this.refresh()
    this.timer = setInterval(this.refresh, 30000)
    window.addEventListener('focus', this.refresh)
    document.addEventListener('visibilitychange', this.refresh)
    approvalMessageEvents.$on('changed', this.refresh)
  },
  beforeDestroy() {
    this.disposed = true
    clearInterval(this.timer)
    window.removeEventListener('focus', this.refresh)
    document.removeEventListener('visibilitychange', this.refresh)
    approvalMessageEvents.$off('changed', this.refresh)
  },
  methods: {
    async refresh() {
      if (document.hidden || this.pending || this.disposed) return
      this.pending = true
      try {
        const response = await approvalMessageSummary()
        if (!response || !response.data) throw new Error('消息数量暂不可用')
        if (!this.disposed) {
          this.unreadCount = Number(response.data.unreadCount) || 0
          this.error = false
        }
      } catch (error) {
        if (!this.disposed) this.error = true
      } finally { this.pending = false }
    },
    open() {
      this.refresh()
      if (this.$route.path !== '/message-center') this.$router.push('/message-center')
    }
  }
}
</script>
<style scoped>
.message-bell { display: inline-flex; align-items: center; justify-content: center; width: 60px; height: 50px; padding: 0; border: 0; background: transparent; vertical-align: top; color: #5a5e66; cursor: pointer; }
.message-bell:hover, .message-bell:focus-visible { background: #f0f6ff; color: #409eff; }
.message-bell i { font-size: 24px; }
.message-bell >>> .el-badge__content { top: 8px; }
</style>
